import styled from 'styled-components';

const SortingRootElement = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  .filter-totalPartners {
    display: flex;
    gap: 4px;
  }
  .filter-sort {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
  }
  .sorting-dropdown{
    box-shadow: none;
    background: none;
    margin-top: 1px;
    font-weight: 600;
    &.Mui-focused{
      background: none;
    }
    &:hover{
      background: none;
    }
    &:focus-visible{
      outline: none;
    }
    &::after, &::before{
      display: none;
    }
    .MuiSelect-select{
      padding: 0 28px 0 0;
      &:focus{
        box-shadow: none;
        border-radius:0;
        background: none;
      }
    }
  }
`;

export default SortingRootElement;
